

import { memberConfigurationResponse } from "../../modules/help/contact.model";
import {ActionType} from "../action-type/index";
interface IinitialState {
    loading:boolean,
    error:any,
    corporateConfigData:memberConfigurationResponse,
    timeStamp:any,
    domiBalance:any,
    dataloaded: null
}

const initialState:IinitialState ={
    loading:false,
    error:null,
    corporateConfigData:null,
    timeStamp:null,
    domiBalance:null,
    dataloaded: null
};

export const fetch_MemberConfig_Reducer = (state:IinitialState = initialState, action) => {
    switch (action.type) {
        case ActionType.FETCH_MEMBERCONFIG_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_MEMBERCONFIG_SUCCESS:
            return {
                ...state,
                loading:false,
                corporateConfigData:action.corporateConfigData,
                timeStamp:action.timeStamp,
                dataloaded: true
            }
        case ActionType.FETCH_MEMBERCONFIG_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
                dataloaded: false
            }
        default:
            return state
    }
}

export const fetch_MemberdomiBalance_Reducer = (state:IinitialState = initialState, action) => {
    switch (action.type) {
        case ActionType.FETCH_MEMBERDOMIBALANCE_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_MEMBERDOMIBALANCE_SUCCESS:
            return {
                ...state,
                loading:false,
                domiBalance:action.domiBalance,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_MEMBERDOMIBALANCE_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}
